export default "__VITE_ASSET__jyhNsI$s__"